import { useForm } from "react-hook-form";
import { Button, Card, Form, Input, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import { Modal, Watermark } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export const ForgotPassword = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { forgotPassword } = LayoutData();
  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get("username");
  const [aktvalues, setAktvalues] = useState({ username: "" });

  const onFinish = (values) => {
    forgotPassword(values.username);
    message.info(
      <>
        "Ein Email wurde an <b>{values.username}</b> gesendet"
      </>
    );
    navigate("/");
  };
  useEffect(() => {
    setAktvalues(username);
  }, [username]);

  return (
    <>
      <Watermark content="Passwort vergessen" style={{ height: "100%" }}>
        <Modal
          title="Passwort vergessen"
          width={400}
          centered
          open={true}
          cancelText="Schließen"
          onCancel={() => {
            navigate("/");
          }}
          //onOk={() => (false)}
          okText="-"
          okButtonProps={{ style: { display: "none" } }} // Hier wird der OK-Button ausgeblendet
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <Card
            title="Passwort zurück setzen"
            style={{
              maxWidth: 400,
              marginTop: 25,
            }}
          >
            <Form
              layout="vertical"
              initialValues={aktvalues}
              onFinish={onFinish}
            >
              <Form.Item
                label="Username / EMail:"
                name="username"
                rules={[
                  {
                    type: "email",
                    message: "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
                  },
                  {
                    required: true,
                    message: "Bitte geben Sie Ihren Benutzernamen als EMail!",
                  },
                ]}
              >
                <Input
                  placeholder="Benutzername als EMail"
                  prefix={<UserOutlined />}
                ></Input>
              </Form.Item>
              <Form.Item>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  //ref={defaultButtonRef}
                >
                  EMail anfordern
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Modal>
      </Watermark>
    </>
  );
};
